import React, { useState, useEffect } from 'react';
import { SeoHead } from './components/SeoHead';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { DlpDemo } from './components/DlpDemo';
import { BudgetSimulator } from './components/BudgetSimulator';
import { AnalyticsShowcase } from './components/AnalyticsShowcase';
import { Features } from './components/Features';
import { ArchitectureView } from './components/ArchitectureView';
import { Comparison } from './components/Comparison';
import { Faq } from './components/Faq';
import { Footer } from './components/Footer';
import { PitchDeck } from './components/deck/PitchDeck';

export const App: React.FC = () => {
  const [currentPath, setCurrentPath] = useState<string>(() => {
    if (typeof window !== 'undefined') {
      return window.location.pathname.toLowerCase();
    }
    return '/';
  });

  useEffect(() => {
    const handleLocationChange = () => {
      setCurrentPath(window.location.pathname.toLowerCase());
    };

    window.addEventListener('popstate', handleLocationChange);
    return () => window.removeEventListener('popstate', handleLocationChange);
  }, []);

  // Check if navigating to pitch deck
  const isPitchDeck =
    currentPath === '/pitch-deck' ||
    currentPath === '/pitch-deck/' ||
    currentPath === '/deck' ||
    currentPath === '/deck/' ||
    (typeof window !== 'undefined' &&
      (window.location.hash === '#pitch-deck' ||
        new URLSearchParams(window.location.search).get('view') === 'pitch-deck'));

  if (isPitchDeck) {
    return <PitchDeck />;
  }

  return (
    <div className="min-h-screen flex flex-col bg-slate-50 dark:bg-navy-900 text-slate-900 dark:text-slate-100 selection:bg-gold-500 selection:text-navy-950 transition-colors duration-200">
      <SeoHead />
      <Header />
      <main className="flex-grow">
        <Hero />
        <DlpDemo />
        <BudgetSimulator />
        <AnalyticsShowcase />
        <Features />
        <ArchitectureView />
        <Comparison />
        <Faq />
      </main>
      <Footer />
    </div>
  );
};

export default App;

